import { fetchCurrentProject } from 'api/queries';
import { EmbeddedMessage, WhatsApp } from 'constants/messageMediums';
import { selectIsIterableGoalsFlagOn } from 'core/userContext';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { useGraphql } from 'utils/hooks/useGraphql';
import {
  CONVERSION_RATE_METRICS_PER_MESSAGE_MEDIUM,
  ENGAGEMENT_CLOSES_DELETES,
  ENGAGEMENT_INBOX_IMPRESSIONS,
  ENGAGEMENT_OPENS_CLICKS,
  ENGAGEMENT_PURCHASE,
} from '../constants';
import { useWhatsAppGAFF } from '../hooks';
import {
  selectCampaignAnalyticsStatsForTimerange,
  selectIsLoading,
  selectMessageMedium,
} from '../selectors';
import { ConversionsCard } from './ConversionsCard';
import { GoalsCard } from './GoalsCard';
import { LayoutTemplate } from './LayoutTemplate';
import { MetricCardSmall } from './MetricCardSmall';
import { MetricChartCard } from './MetricChartCard';
import { OverviewRowWithTwoEqualColumns } from './Styled';

export const CampaignAnalyticsEngagement = () => {
  const statsForTimeRange = useSelector(selectCampaignAnalyticsStatsForTimerange);
  const messageMedium = useSelector(selectMessageMedium);
  const isLoading = useSelector(selectIsLoading);
  const isIterableGoalsFlagOn = useSelector(selectIsIterableGoalsFlagOn);
  const { data = {} } = useGraphql(fetchCurrentProject, {});
  const isWhatsAppGAEnabled = useWhatsAppGAFF();
  const { showRevenue } = data?.currentProject || {};
  const conversions = statsForTimeRange?.results?.Conversions?.value || [];
  const conversionRateLabel = `Conversions / ${CONVERSION_RATE_METRICS_PER_MESSAGE_MEDIUM[messageMedium]}`;
  const conversionRateDividend =
    statsForTimeRange?.results?.[CONVERSION_RATE_METRICS_PER_MESSAGE_MEDIUM[messageMedium]]
      ?.value || 1;
  const isEmbedded = messageMedium === EmbeddedMessage;
  const isWhatsApp = messageMedium === WhatsApp;
  const isWhatsAppGA = isWhatsApp && isWhatsAppGAEnabled;

  return (
    <LayoutTemplate pageName="Engagement" canShowFPOBanner>
      {!isEmbedded && (!isWhatsApp || isWhatsAppGA) && (
        <ConversionsCard
          conversions={conversions}
          conversionRateLabel={conversionRateLabel}
          conversionRateDividend={conversionRateDividend}
        />
      )}
      {isIterableGoalsFlagOn && conversions.length ? (
        <GoalsCard goals={conversions.map(({ eventName }) => eventName)} />
      ) : (
        <></>
      )}
      {showRevenue && !isEmbedded && (!isWhatsApp || isWhatsAppGA) && (
        <MetricChartCard
          messageMedium={messageMedium}
          statsForTimeRange={statsForTimeRange}
          isLoading={isLoading}
          cardType={ENGAGEMENT_PURCHASE}
        />
      )}
      <OverviewRowWithTwoEqualColumns>
        <MetricCardSmall
          messageMedium={messageMedium}
          statsForTimeRange={statsForTimeRange}
          isLoading={isLoading}
          cardType={ENGAGEMENT_CLOSES_DELETES}
        />
        <MetricCardSmall
          messageMedium={messageMedium}
          statsForTimeRange={statsForTimeRange}
          isLoading={isLoading}
          cardType={ENGAGEMENT_INBOX_IMPRESSIONS}
        />
      </OverviewRowWithTwoEqualColumns>
      <MetricChartCard
        messageMedium={messageMedium}
        statsForTimeRange={statsForTimeRange}
        isLoading={isLoading}
        cardType={ENGAGEMENT_OPENS_CLICKS}
      />
    </LayoutTemplate>
  );
};

export default withRouter(CampaignAnalyticsEngagement);
